var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.32 16.002h2.682M14.661 16.002V11l-1.46 1.32",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.148 13.164l.827-4.827a2.001 2.001 0 00-1.973-2.339H4.998a2.001 2.001 0 00-1.973 2.338l.827 4.827c.038.223.038.452 0 .675l-.827 4.827a2.001 2.001 0 001.973 2.34h14.005a2 2 0 001.972-2.339l-.827-4.827a2.014 2.014 0 010-.675z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.003 5.998l.113-.663a2 2 0 00-1.972-2.338H6.856a2 2 0 00-1.972 2.338l.113.663M7.998 11.96c.16-.55.646-.96 1.247-.96.728 0 1.32.59 1.32 1.32 0 .652-.53 1.181-1.182 1.181.652 0 1.181.53 1.181 1.181 0 .729-.59 1.32-1.32 1.32-.6 0-1.087-.41-1.246-.96",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCalendarSchedule;